export default __webpack_public_path__ + "static/media/5.285bafe2.jpg";